import { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Entete from "./dataset/Entete";
import { ThemeContext } from "./ThemeContext";
import img_profil from "../assets/Images/Logo_entreprise.webp";
import Avatar from "@mui/material/Avatar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCamera,
    faBell,
    faMessage,
    faEnvelope,
    faLocationDot,
    faPhone,
    faFile,
    faEye,
    faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Button from "@mui/material/Button";
import {
    Form,
    FormControl,
    FormLabel,
    FormGroup,
    FormSelect,
    Spinner,
    InputGroup,
} from "react-bootstrap";

import { toast } from "react-toastify";
import APIAdmin from "../Authentification/apiAdmin";
import AjouterSousCompte from "./AjouterSousCompte";
// import "../../Styles/AdminDashbord/settings.css";


const Settings = () => {
    const [showPopUp, setshowPopUp] = useState(false);

    const navigate = useNavigate();

    const [showSousComptePopup, setShowSousComptePopup] = useState(false);
    const [sousComptes, setSousComptes] = useState([]);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    useEffect(() => {
        const isAnyPopupOpen = showPopUp;

        document.body.style.overflow = isAnyPopupOpen ? "hidden" : "auto";

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showPopUp]);
    const { theme } = useContext(ThemeContext);

    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        country: "",
        email: "",
        city: "",
        BP: "",
        entreprise_name: "",
        adresse: "",
        phone: "",
        password: "",
        password_confirmation: "",
    });

    const [errors, setErrors] = useState({});
    const [isLoading, setLoading] = useState(false);

    const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]{2,30}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    useEffect(() => {
        const fetchAdmin = async () => {
            try {
                const token = localStorage.getItem("adminToken");
                if (!token) {
                    navigate("/admin/login", { replace: true });
                    return;
                }

                const response = await APIAdmin.get("/admin/admins");

                const data = response.data?.admin || response.data;
                setForm((prev) => ({
                    ...prev,
                    firstName: data.firstName || "",
                    lastName: data.lastName || "",
                    country: data.country || "",
                    email: data.email || "",
                    city: data.city || "",
                    BP: data.BP || "",
                    entreprise_name: data.entreprise_name || "",
                    adresse: data.adresse || "",
                }));
                let userPhone = data.phone || "";

                userPhone = userPhone.replace(/^(\+?229)/, "");
                userPhone = userPhone.replace(/\D/g, "");
                userPhone = userPhone.slice(0, 10);

                const formattedPhone = userPhone.replace(/(\d{2})(?=\d)/g, "$1 ");

                setForm((prev) => ({
                    ...prev,
                    phone: formattedPhone.trim(),
                }));
                // setIsSuperAdmin(data.role === "super_admin");
                setIsSuperAdmin(data.role === "super_admin" || data.role == null);
                if (data.role === "super_admin") {
                    fetchSousComptes();
                }
            } catch (error) {
                console.error("Erreur lors du chargement du profil:", error);

                if (error.response?.status === 401) {
                    localStorage.removeItem("token");
                    toast.warning("Votre session a expiré, veuillez vous reconnecter.");
                    navigate("/admin/login", { replace: true });
                }
            }
        };
        fetchAdmin();
    }, [navigate]);

    const fetchSousComptes = async () => {
        try {
            const response = await APIAdmin.get("/admin/sous-comptes");
            setSousComptes(response.data);
        } catch (error) {
            if (error.response?.status !== 403) {
                console.error("Erreur lors du chargement des sous-comptes:", error);
            }
        }
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" });
    };
    const handleChangePhone = (e) => {
        let value = e.target.value.replace(/\D/g, "");
        value = value.slice(0, 10);
        value = value.replace(/(\d{2})(?=\d)/g, "$1 ");

        setForm((prev) => ({ ...prev, phone: value }));
        setErrors((prev) => ({ ...prev, phone: "" }));
    };

    const validate = () => {
        const newErrors = {};

        if (!form.firstName.trim())
            newErrors.firstName = "Le prénom est obligatoire.";
        else if (!nameRegex.test(form.firstName))
            newErrors.firstName =
                "Le prénom ne doit contenir que des lettres valides.";

        if (!form.lastName.trim()) newErrors.lastName = "Le nom est obligatoire.";
        else if (!nameRegex.test(form.lastName))
            newErrors.lastName = "Le nom ne doit contenir que des lettres valides.";

        if (!form.country) newErrors.country = "Choisissez un pays.";

        if (!form.email.trim())
            newErrors.email = "L'adresse email est obligatoire.";
        else if (!emailRegex.test(form.email.trim()))
            newErrors.email = "L'adresse email est invalide.";

        if (!form.city) newErrors.city = "Choisissez une ville";

        const cleanPhone = form.phone.replace(/\s/g, "");

        if (!form.phone) {
            newErrors.phone = "Entrez un numéro de téléphone";
        } else if (!/^01\d{8}$/.test(cleanPhone)) {
            newErrors.phone =
                "Le numéro doit commencer par 01 et contenir 10 chiffres au total.";
        } else {
            const secondPair = parseInt(cleanPhone.substring(2, 4), 10);
            if (secondPair < 50 || secondPair > 99) {
                newErrors.phone =
                    "Les deux chiffres après '01' doivent être compris entre 20 et 29.";
            }
        }

        if (!form.BP) newErrors.BP = "Entrez votre BP";

        if (!form.entreprise_name)
            newErrors.entreprise_name = "Veuillez entrer un nom valide.";

        if (!form.adresse)
            newErrors.adresse = "Veuillez entrer une adresse valide.";

        if (form.password || form.password_confirmation) {
            if (form.password.length < 6) {
                newErrors.password = "Le mot de passe doit contenir au moins 6 caractères.";
            }
            if (form.password !== form.password_confirmation) {
                newErrors.password_confirmation = "Les mots de passe ne correspondent pas.";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            setLoading(true);
            const token = localStorage.getItem("adminToken");
            if (!token) {
                toast.error("Session expirée. Veuillez vous reconnecter.");
                navigate("/admin/login", { replace: true });
                return;
            }
            const cleanPhone = form.phone.replace(/\s/g, "");

            const payload = {
                ...form,
                phone: cleanPhone,
                BP: form.BP !== "" && form.BP !== null ? String(form.BP) : "",
            };

            if (!form.password) {
                delete payload.password;
                delete payload.password_confirmation;
            }

            const response = await APIAdmin.put("/admin/admins-info", payload, {
                headers: { Authorization: `Bearer ${token}` },
            });

            toast.success(response.data.message || "Profil mis à jour avec succès !");

            setForm((prev) => ({ ...prev, password: "", password_confirmation: "" }));
            setShowPassword(false);
            setShowConfirmPassword(false);
        } catch (error) {
            console.error("Erreur :", error);
            if (error.response?.status === 422) {
                setErrors(error.response.data.errors || {});
            } else if (error.response?.status === 401) {
                localStorage.removeItem("adminToken");
                toast.warning("Votre session a expiré, veuillez vous reconnecter.");
                navigate("/admin", { replace: true });
            } else {
                toast.error("Une erreur est survenue. Veuillez réessayer.");
            }
        } finally {
            setLoading(false);
        }
    };

    const logout = async () => {
        const token = localStorage.getItem("adminToken");
        try {
            await APIAdmin.post(
                "/admin/logout",
                {},
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            localStorage.removeItem("adminToken");
            toast.success("Déconnexion réussie");
            navigate("/admin/");
        } catch (err) {
            toast.error("Erreur lors de la déconnexion");
        }
    };

    const handleDeleteSousCompte = async (id) => {
        try {
            const token = localStorage.getItem("adminToken");
            await APIAdmin.delete(`/admin/sous-comptes/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success("Sous-compte supprimé");
            setSousComptes((prev) => prev.filter((a) => a.id !== id));
        } catch (error) {
            toast.error("Erreur lors de la suppression");
        }
    };

    const handleToggleSousCompte = async (id) => {
        try {
            const token = localStorage.getItem("adminToken");
            const response = await APIAdmin.patch(
                `/admin/sous-comptes/${id}/statut`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );
            toast.success(response.data.message);
            setSousComptes((prev) =>
                prev.map((a) => (a.id === id ? response.data.admin : a))
            );
        } catch (error) {
            toast.error("Erreur lors du changement de statut");
        }
    };

    return (
        <div className="settings-page">
            <Entete title="Paramètres" />

            <div className="">
                <div className="row mt-4">
                    {/* Première colonne  */}

                    <div className="col-md-3 col-12 me-3 border-1 d-flex flex-column p-0">
                        <div
                            className="col shadow-sm border d-flex flex-column align-items-center justify-content-center p-2"
                            style={{ backgroundColor: theme === "dark" ? "black" : "white" }}
                        >
                            <div className="d-flex position-relative">
                                <Avatar
                                    src={img_profil}
                                    alt=""
                                    style={{
                                        width: "100px",
                                        height: "100px",
                                        border: "2px solid #FA7F1B",
                                    }}
                                />
                                <div
                                    className="d-flex position-absolute bottom-0 end-0 rounded-circle p-2"
                                    style={{
                                        backgroundColor: "gray",
                                        border: "1px solid #FA7F1B",
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCamera} />
                                </div>
                            </div>
                            <h5 className="fw-bold petit_titre">
                                {form.lastName}   {form.firstName}
                            </h5>
                            <div className="bg-primary text-white border border-1 rounded-3 text-center p-1 petit_titre">
                                Administrateur
                            </div>
                            <p className="text-primary texte_brut pt-2">
                                Dernière visite : 01/04/2026
                            </p>
                            <Button
                                className=" w-100 rounded-5"
                                onClick={() => logout()}
                                style={{ backgroundColor: "red", color: "white" }}
                            >
                                Déconnecter
                            </Button>
                        </div>

                        <div
                            className="col shadow-sm border mt-4 d-flex flex-column align-items-center justify-content-center p-2"
                            style={{ backgroundColor: theme === "dark" ? "black" : "white" }}
                        >
                            <div className="row">
                                <div className="col-1 d-flex align-items-center">
                                    <FontAwesomeIcon icon={faBell} style={{ color: "gold" }} />
                                </div>
                                <div className="col petit_titre">Notifications (0)</div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-1 d-flex align-items-center">
                                    <FontAwesomeIcon icon={faMessage} style={{ color: "blue" }} />
                                </div>
                                <div className="col petit_titre">Messages (0)</div>
                            </div>
                        </div>

                        <div
                            className="col shadow-sm border border-1 d-flex flex-column mt-4 p-2 px-3"
                            style={{ backgroundColor: theme === "dark" ? "black" : "white" }}
                        >
                            <span className="texte_brut">
                                {" "}
                                <FontAwesomeIcon icon={faEnvelope} /> {form.email}
                            </span>
                            <span className="texte_brut pt-2">
                                {" "}
                                <FontAwesomeIcon icon={faLocationDot} /> Rue 2106, Cotonou,
                                9937+8H Cotonou
                            </span>
                            <span className="texte_brut pt-2">
                                {" "}
                                <FontAwesomeIcon icon={faPhone} /> (+229) 01 65 00 29 29
                            </span>
                            <span className="texte_brut pt-2">
                                {" "}
                                <FontAwesomeIcon icon={faWhatsapp} /> (+229) 01 65 00 28 00
                            </span>
                            <span className="texte_brut pt-2">
                                {" "}
                                <FontAwesomeIcon icon={faFile} /> Fichier d'informations du
                                profil
                            </span>
                        </div>
                    </div>

                    {/* Deuxième colonne card  */}

                    <div
                        className="col  border border-1 shadow-sm p-3"
                        style={{ backgroundColor: theme === "dark" ? "black" : "white" }}
                    >
                        <h5 className="taux_moyen">Détails du profil</h5>
                        <Form method="post" onSubmit={handleSubmit}>
                            <div className="row mt-1 g-2">
                                <FormGroup className="col-12 col-sm-6">
                                    <FormLabel className="texte_brut">Nom</FormLabel>
                                    <FormControl
                                        name="lastName"
                                        placeholder="Group Nol"
                                        isInvalid={!!errors.lastName}
                                        value={form.lastName}
                                        onChange={handleChange}
                                    />
                                    <FormControl.Feedback type="invalid">
                                        {errors.lastName}
                                    </FormControl.Feedback>
                                </FormGroup>
                                <FormGroup className="col-12 col-sm-6">
                                    <FormLabel className="texte_brut">Prénom</FormLabel>
                                    <FormControl
                                        name="firstName"
                                        placeholder="Market"
                                        isInvalid={!!errors.firstName}
                                        value={form.firstName}
                                        onChange={handleChange}
                                    />
                                    <FormControl.Feedback type="invalid">
                                        {errors.firstName}
                                    </FormControl.Feedback>
                                </FormGroup>
                            </div>
                            <div className="row mt-1 g-2">
                                <FormGroup className="col-12 col-sm-6">
                                    <FormLabel className="texte_brut">Pays</FormLabel>
                                    <FormSelect
                                        name="country"
                                        isInvalid={!!errors.country}
                                        value={form.country}
                                        onChange={handleChange}
                                    >
                                        <option value="">--Choisir--</option>
                                        <option value="Bénin">Bénin</option>
                                        <option value="Togo">Togo</option>
                                        <option value="Nigéria">Nigéria</option>
                                        <option value="Niger">Niger</option>
                                    </FormSelect>
                                </FormGroup>
                                <FormGroup className="col-12 col-sm-6">
                                    <FormLabel className="texte_brut">Ville</FormLabel>
                                    <FormSelect
                                        name="city"
                                        isInvalid={!!errors.city}
                                        value={form.city}
                                        onChange={handleChange}
                                    >
                                        <option value="">--Choisir--</option>
                                        <option value="Cotonou">Cotonou</option>
                                        <option value="Ouidah">Ouidah</option>
                                    </FormSelect>
                                </FormGroup>
                            </div>
                            <div className="row mt-1 g-2">
                                <FormGroup className="col-12 col-sm-6">
                                    <FormLabel className="texte_brut">Email</FormLabel>
                                    <FormControl
                                        name="email"
                                        placeholder="moi@gmail.com"
                                        value={form.email}
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                    />
                                    <FormControl.Feedback type="invalid">
                                        {errors.email}
                                    </FormControl.Feedback>
                                </FormGroup>
                                <FormGroup className="col-12 col-sm-6">
                                    <FormLabel className="texte_brut">
                                        Numéro de téléphone
                                    </FormLabel>
                                    <FormControl
                                        name="phone"
                                        placeholder="01 ** ** ** **"
                                        isInvalid={!!errors.phone}
                                        value={form.phone}
                                        onChange={handleChangePhone}
                                    />
                                    <FormControl.Feedback type="invalid">
                                        {errors.phone}
                                    </FormControl.Feedback>
                                </FormGroup>
                            </div>
                            <div className="row mt-1 g-2">
                                <FormGroup className="col-12 col-sm-6">
                                    <FormLabel className="texte_brut">BP</FormLabel>
                                    <FormControl
                                        name="BP"
                                        placeholder="**"
                                        type="number"
                                        isInvalid={!!errors.BP}
                                        value={form.BP}
                                        onChange={handleChange}
                                    />
                                    <FormControl.Feedback type="invalid">
                                        {errors.BP}
                                    </FormControl.Feedback>
                                </FormGroup>
                                <FormGroup className="col-12 col-sm-6">
                                    <FormLabel className="texte_brut">
                                        Nom de l'entreprise
                                    </FormLabel>
                                    <FormControl
                                        name="entreprise_name"
                                        placeholder="Group Nol Market"
                                        isInvalid={!!errors.entreprise_name}
                                        value={form.entreprise_name}
                                        onChange={handleChange}
                                    />
                                    <FormControl.Feedback type="invalid">
                                        {errors.entreprise_name}
                                    </FormControl.Feedback>
                                </FormGroup>
                            </div>
                            <div className="row mt-1 g-2">
                                <FormGroup className="col-12 col-sm-6">
                                    <FormLabel className="texte_brut">Nouveau mot de passe</FormLabel>
                                    <InputGroup>
                                        <FormControl
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            placeholder="Laisser vide pour ne pas changer"
                                            value={form.password}
                                            onChange={handleChange}
                                            isInvalid={!!errors.password}
                                        />
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => setShowPassword((prev) => !prev)}
                                            style={{ border: "1px solid #ced4da" }}
                                        >
                                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                        </Button>
                                    </InputGroup>
                                    {errors.password && (
                                        <div className="text-danger petit_titre mt-1">
                                            {errors.password}
                                        </div>
                                    )}
                                </FormGroup>
                                <FormGroup className="col-12 col-sm-6">
                                    <FormLabel className="texte_brut">Confirmer le mot de passe</FormLabel>
                                    <InputGroup>
                                        <FormControl
                                            type={showConfirmPassword ? "text" : "password"}
                                            name="password_confirmation"
                                            placeholder="****"
                                            value={form.password_confirmation}
                                            onChange={handleChange}
                                            isInvalid={!!errors.password_confirmation}
                                        />
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => setShowConfirmPassword((prev) => !prev)}
                                            style={{ border: "1px solid #ced4da" }}
                                        >
                                            <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                                        </Button>
                                    </InputGroup>
                                    {errors.password_confirmation && (
                                        <div className="text-danger petit_titre mt-1">
                                            {errors.password_confirmation}
                                        </div>
                                    )}
                                </FormGroup>
                            </div>
                            <div className="row mt-1">
                                <FormGroup className="col-12">
                                    <FormLabel className="texte_brut">Adresse</FormLabel>
                                    <FormControl
                                        name="adresse"
                                        placeholder="Fidjrossè, Houenoussou"
                                        isInvalid={!!errors.adresse}
                                        value={form.adresse}
                                        onChange={handleChange}
                                    />
                                    <FormControl.Feedback type="invalid">
                                        {errors.adresse}
                                    </FormControl.Feedback>
                                </FormGroup>
                            </div>
                            <Button
                                className="text-lowercase petit_titre rounded-5 bg-primary mt-3 settings-submit-btn"
                                style={{ color: "white" }}
                                type="submit"
                            >
                                {isLoading ? (
                                    <Spinner size="sm" animation="border" />
                                ) : (
                                    "Changer les informations"
                                )}
                            </Button>
                        </Form>

                        <h5 className="taux_moyen mt-4">
                            Outils du paneau d'administration
                        </h5>
                        {isSuperAdmin && (
                            <button
                                className="bg-info p-2 b-0 rounded-5 border-0 settings-subaccount-btn"
                                style={{ color: "white" }}
                                onClick={() => setShowSousComptePopup(true)}
                            >
                                Ajouter un sous-compte
                            </button>
                        )}
                    </div>
                </div>
                {isSuperAdmin && sousComptes.length > 0 && (
                    <div className="mt-4">
                        <h6 className="petit_titre fw-bold">Sous-comptes ({sousComptes.length})</h6>
                        {sousComptes.map((sc) => (
                            <div
                                key={sc.id}
                                className="d-flex flex-column flex-sm-row justify-content-sm-between align-items-start align-items-sm-center border-bottom py-2 gap-2"
                            >
                                <div>
                                    <span className="texte_brut fw-bold">
                                        {sc.firstName} {sc.lastName}
                                    </span>
                                    <br />
                                    <small className="text-muted">{sc.email}</small>
                                    <br />
                                    <small className={sc.is_active ? "text-success" : "text-danger"}>
                                        {sc.is_active ? "Actif" : "Désactivé"}
                                    </small>
                                </div>
                                <div className="d-flex gap-2">
                                    <Button
                                        size="sm"
                                        variant="outline-secondary"
                                        onClick={() => handleToggleSousCompte(sc.id)}
                                    >
                                        {sc.is_active ? "Désactiver" : "Activer"}
                                    </Button>
                                    <Button
                                        size="sm"
                                        variant="outline-danger"
                                        onClick={() => handleDeleteSousCompte(sc.id)}
                                    >
                                        Supprimer
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {showSousComptePopup && (
                <AjouterSousCompte
                    show={showSousComptePopup}
                    onClose={() => setShowSousComptePopup(false)}
                    onCreated={(newAdmin) => setSousComptes((prev) => [newAdmin, ...prev])}
                />
            )}
        </div>
    );
};

export default Settings;